import axios, { AxiosError, AxiosResponse } from "axios";
import { GetSessionToken, store } from "./store";
import { Router } from "../router";
import { NetworkError, NetworkErrorBody } from "../models/networkError";
import { NetworkErrorCode } from "../models/enum/networkErrorCode";
import { logout } from "./logout";
import { logoutModalAtom } from "../atoms/logoutModalAtom";
import { triggerLogoutModal } from "../components/common/logoutDialog";

const HttpClient = axios.create({
	timeout: 5000,
});

interface OnSiteApiDto {
	data: any;
}

HttpClient.interceptors.request.use((request) => {
	console.debug("Starting Request", JSON.stringify(request, null, 2));

	const sessionKey = GetSessionToken();
	if (sessionKey) {
		request.headers.set("Authorization", `Bearer ${sessionKey}`);
	}
	request.headers.set("X-FEV-APP-SOURCE", "ONSITE_TOOL");
	return request;
});

HttpClient.interceptors.response.use(
	(response: AxiosResponse<OnSiteApiDto>) => {
		console.debug("Response:", JSON.stringify(response, null, 2));
		return response;
	},
	async (error: AxiosError) => {
		console.error("Response:", JSON.stringify(error, null, 2));
		if (error.response?.status === 401) {
			const userAgent = window.navigator.userAgent;
			if (userAgent.match(/(?=.*WeverseBackstage)/)) {
				// backstage 에서만 확인 모달
				await triggerLogoutModal();
			}
			logout();
			throw new NetworkError(
				error.response?.status,
				error.response?.data as NetworkErrorBody | undefined,
			);
		}

		const networkError = new NetworkError(
			error.response?.status,
			error.response?.data as NetworkErrorBody | undefined,
		);

		// 보안 서약서 동의가 필요하다는 코드로 내려온 응답일 때만 보안 서약서 페이지로 이동
		if (networkError.body?.code === NetworkErrorCode.SECURITY_PLEDGE_REQUIRED) {
			Router.navigate("/security-pledge", { replace: true });
			throw networkError;
		}

		if (networkError.body?.code === "MAINTENANCE") {
			let navOption;
			if (networkError.body.args && networkError.body.args.length > 2) {
				const [month, day, startAt, endAt] = networkError.body.args;
				navOption = {
					state: {
						period: { month, day, startAt, endAt },
					},
				};
			}

			Router.navigate("/maintenance", navOption).then();
		}
		throw networkError;
	},
);

export default HttpClient;
